import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

import { AdminListSkeleton } from "@/components/skeleton/list-skeleton";
import { useTRPC } from "@/lib/trpc";
import { routes } from "@/routes";

import { PlayerListItem } from "../player-list/player-list-item";

export function AdminPlayersList() {
  const { t } = useTranslation(["common"]);
  const navigate = useNavigate();
  const trpc = useTRPC();
  const { data: players, status } = useQuery(trpc.player.listPlayers.queryOptions(undefined, { refetchOnWindowFocus: false }));

  if (status === "pending") {
    return <AdminListSkeleton />;
  }

  if (status === "error" || !players) {
    return (
      <span className="rounded-[18px] border border-neutral-400 bg-white p-4 text-center text-neutral-600 md:border-0">
        {t("common:no-player-found")}
      </span>
    );
  }

  return (
    <div className="pt-4">
      <div className="flex flex-col gap-2 data-[state=inactive]:hidden md:gap-0 md:rounded-[18px] md:border md:border-neutral-400">
        {players.map(player => (
          <PlayerListItem
            key={player.userId}
            player={player}
            fromPath={routes.admin}
            onClick={() => navigate(routes.getAdminPlayerProfilePath(player.userId), { state: { fromPath: routes.admin } })}
            className="cursor-pointer"
          />
        ))}
      </div>
    </div>
  );
}
